import React from 'react';
import { AppBar, Toolbar, useMediaQuery, useTheme } from '@mui/material';
import { DesktopHeader } from './DesktopHeader';
import { MobileHeader } from './MobileHeader';

export type NavItem = {
	label: string;
	href: string;
};

export const navItems: NavItem[] = [
	{ label: 'Startseite', href: '/' },
	// { label: 'Unsere Kanzlei', href: '/notready' },
	// { label: 'Was Sie erwartet', href: '/notready' },
	// { label: 'Kontakt', href: '/notready' },
];

export const Header: React.FC = () => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

	return (
		<AppBar
			position="static"
			elevation={0}
			sx={{
				backgroundColor: '#FAFAFB',
				color: 'black',
				justifyContent: 'center',
			}}
		>
			<Toolbar sx={{ py: 1 }}>
				{isMobile ? <MobileHeader /> : <DesktopHeader />}
			</Toolbar>
		</AppBar>
	);
};
